interface IRemoveButtonProps {
  label: string;
  onClick: () => void;
  className?: string;
}

const RemoveButton = (props: IRemoveButtonProps) => {
  return (
    <button
      type="button"
      className={`text-red-500 underline underline-offset-2 flex items-center gap-1 hover:opacity-80 text-size-14 whitespace-nowrap cursor-pointer ${props.className || ''}`}
      onClick={props.onClick}
      title={props.label}
    >
      <img
        src="/assets/images/iconClose.svg"
        alt={props.label}
        className="w-7 h-7 flex-shrink-0"
      />
      <span className="text-size-16 mb-2 ml-2">{props.label}</span>
    </button>
  );
};

export default RemoveButton;

